<cads-field [config]="_fieldConfig()" [focused]="_focused()">
  <textarea
    class="cads-textarea__el"
    [id]="_inputId()"
    [value]="_value()"
    [disabled]="_disabled()"
    [placeholder]="config().placeholder ?? ''"
    [attr.rows]="config().rows ?? 4"
    [attr.maxlength]="config().maxLength ?? null"
    [attr.minlength]="config().minLength ?? null"
    [attr.wrap]="config().wrap ?? null"
    [attr.autocomplete]="config().autocomplete ?? null"
    [attr.aria-invalid]="_hasError() ? 'true' : null"
    [attr.aria-required]="config().required === true ? 'true' : null"
    [attr.aria-describedby]="_showCaption() ? _captionId() : null"
    (input)="_onInput($event)"
    (focus)="_onFocus()"
    (blur)="_onBlur()"
  ></textarea>
  <ng-content select="[cadsFieldCaption]" />
</cads-field>
@if (_showCounter()) {
  <p class="cads-textarea__counter" aria-hidden="true">{{ _value().length }} / {{ config().maxLength }}</p>
}
